module.exports = __webpack_public_path__ + "static/Pirouz-17a6352d7aa9a282cfba91dc86ef97bd.png";